import { TravelXFeatureFlags } from 'src/app/shared/models/enums/team-feature-flags/travelx-feature-flags.enum';
import { WayfarersFlags } from 'src/app/shared/models/enums/team-feature-flags/wayfarers-feature-flags.enum';
import { AccountManagementFeatureFlags } from './team-feature-flags/account-management-feature-flags.enum';
import { AccountOperationsFeatureFlags } from './team-feature-flags/account-operations-feature-flags.enum';
import { AlgoFeatureFlags } from './team-feature-flags/algo-feature-flags.enum';
import { AyaWannaConnectFeatureFlags } from './team-feature-flags/aya-wanna-connect-feature-flags.enum';
import { BabaYagaFeatureFlags } from './team-feature-flags/baba-yaga-feature-flags.enum';
import { CodeBustersFeatureFlags } from './team-feature-flags/code-busters-feature-flags.enum';
import { CNXFeatureFlags } from './team-feature-flags/connexus-feature-flags.enum';
import { EHFeatureFlags } from './team-feature-flags/eh-feature-flags.enum';
import { HWFeatureFlags } from './team-feature-flags/hw-feature-flags.enum';
import { ItsOverNineThousandFeatureFlags } from './team-feature-flags/io9k-feature.flags.enum';
import { LocumsFlags } from './team-feature-flags/locums-feature-flags.enum';
import { MicDropFeatureFlags } from './team-feature-flags/mic-drop-feature-flags.enum';
import { PathfindersFlags } from './team-feature-flags/pathfinders-feature-flags.enum';
import { PayrollTimecardFeatureFlags } from './team-feature-flags/payroll-timecard-feature-flags.enum';
import { ProgramManagementFeatureFlags } from './team-feature-flags/program-management-feature-flags';
import { StaftPunkFeatureFlags } from './team-feature-flags/staft-punk-feature-flags.enum';
import { StarBucksFeatureFlags } from './team-feature-flags/star-bucks-feature-flags.enum';
import { SupersonicFeatureFlags } from './team-feature-flags/supersonic-feature-flags.enum';
import { SyncOrSwimFeatureFlags } from './team-feature-flags/sync-or-swim-feature-flags.enum';
import { TPFeatureFlags } from './team-feature-flags/tp-feature-flags.enum';
import { TravelRecruitingFlags } from './team-feature-flags/travel-recruiting-flags.enum';
import { AyaKiddingMeFeatureFlags } from './team-feature-flags/aya-kidding-me-feature-flags';
import { TestFeatureFlags } from 'src/app/shared/models/enums/test-feature-flags/test-feature-flags.enum';
import { PerDizzleFeatureFlags } from './team-feature-flags/per-dizzle-feature-flags.enum';
import { HotFeatureFlags } from './team-feature-flags/hot-feature-flags.enum';
import { ESPressoFeatureFlags } from './team-feature-flags/espresso-feature-flags.enum';

export enum FeatureFlags {
    // **** WFD Flags ****
    AN_32748_WFD_WORKHISTORY_OVERLAPS_ENHANCEMENTS_NOVA = 'AN-32748_WFD_WORKHISTORY_OVERLAPS_ENHANCEMENTS_NOVA',
    WFD_149_WorkHistory_Positions_Held = 'EPIC-WFD-149_NOVA_WORK_HISTORY_POSITION_HELD',
    WFD_3552_clinical_match = 'WFD-3552-clincial-match-percentage',
    WFD_3626_Hospital_System_Grid_With_Custom_Fields = 'EPIC_WFD-3626_Hospital_System_Grid_With_Custom_Fields',
    WFD_3853_Click_Clear_To_Start_ColorCoding = 'WFD_3853_Click_Clear_To_Start_ColorCoding',
    WFD_3761_Additional_Search = 'WFD-3761-additional-search',
    WFD_4011_System_Grid_First_Tab = 'wfd-4011-system-grid-first-tab',
    WFD_3684_System_Grid_Import = 'wfd-3684-system-grid-import',
    WFD_3944_Facility_System_Level_Save_Columns = 'WFD_3944_Facility_System_Level_Save_Columns',
    WFD_3925_Payroll_Employee_Number = 'WFD-3925-payroll-employee-number',
    WFD_4010_Facility_System_Level_Reset_Columns = 'WFD_4010_Facility_System_Level_Reset_Columns',
    WFD_4243_Overbook_WFD_Priority = 'WFD-4243-overbook-priority-levels',
    WFD_3682_Save_Load_Filters = 'EPIC_WFD_3682_Save_Load_Filters',
    WFD_4229_Priority_Recruiter_Livelist = 'wfd-4229-wdf-priority-recruiter-livelist',
    WFD_4047_Unhidden_Columns_Become_Hidden_When_Sorting = 'WFD-4047-Unhidden-Columns-Become-Hidden-When-Sorting',
    WFD_4233_Wfd_Priority = 'wfd-4233-wfd-priority-system-grid',
    WFD_4195_track_traveler_identification_status = 'WFD-4195-track-traveler-identification-status',

    // **** WFD Flags ****

    // **** SRE Flags ****
    // **** SRE Flags ****

    SendMyAyaClinicianContract = 'SendMyAyaClinicianContract',
    FeatureA = 'FeatureA',
    FeatureB = 'FeatureB',
    ComplianceRequirementCategoriesGrid = 'ComplianceRequirementCategoriesGrid',
    EnableWorkforceSolutionsFacilitiesExport = '20220517_TD_8254_ADD_EXPORT_OPTIONS_TO_WFS_FACILITIES',
    TCBillRateBasedOnEffectiveDate = '20220607_AN-20899_TC_BILL_RATE_BASED_ON_EFFECTIVE_DATE',
    NewSubcontractorMarginCalculator = '20220503_TD-7953_SHOW_NEW_UI',
    EnableShippingRequestPOBox = '20220712_TD-7581_SHIPPING_REQUESTS_PO_BOX',
    RecruitingDashboardUseSignalR = '20220714_AN-20395_REC_DASHBOARD_USE_SIGNALR',
    EnableVendorAdminGridFilterRefreshingAfterRecordUpdate = '20220810_TD-8997_ENABLE_VENDOR_ADMIN_GRID_FILTER_REFRESHING_AFTER_RECORD_UPDATE',
    DevOpsFlag = 'DEVOPS_FLAG',
    MoneyMovementValidations = 'MARGIN_MONEY_MOVEMENT_VALIDATIONS',
    RecruitingDashboardJobAlertUseSignalR = 'REC_DASHBOARD_JOB_ALERTS_SIGNALR',
    NovaCandidateLeadScoreDisplay = 'NOVA_CANDIDATE_LEAD_SCORE_DISPLAY',
    EnableClinicalUnitDescriptionUpgrade = 'ENABLE_CLINICAL_UNIT_DESCRIPTION_UPGRADE',
    StartEndDateWfdBookedCandidate = 'AN-38794_START_END_DATE_WFD_BOOKED_CANDIDATE',

    EnableRunIntegrationFromDashboard = 'ENABLE_INTEGRATION_RUN_FROM_DASHBOARD',
    AccessSecureUDLinks = 'ACCESS_SECURE_UD_LINKS',
    AccessSecureUdLinksByFacilities = 'access-secure-ud-links',
    EnableNurseAvailabilityFacilitiesFilter = 'NURSE_AVAILABILITY_FACILITIES_FILTER',
    RemoveCancelledByAgencyOption = 'REMOVE_CANCELLED_AGENCY_OPTION',
    DisableCancelledByAgencyOption = 'DISABLE_CANCELLED_AGENCY_OPTION',
    EnableConnectExpenses = 'ENABLE_CONNECT_EXPENSES',
    IncludePdProfileShiftHistoryTabsInRecruitingProfile = 'include-pd-profile-shift-history-tabs-in-recruiting-profile',
    VmsRentalCarEditTotalDays = 'vms-rental-car-expense-edit-total-days',
    AccountManagerFilter = 'ACCOUNT_MANAGEMENT_FILTER',
    EnhanceNovaTimeGridPerformance = 'nova-timecard-grid-performance-improvements',
    AllowExpenseStatusUpdateInNova = 'allow-expense-status-update-in-nova',
    EnableBulkTimecardCreation = 'enable-bulk-timecard-creation'
}

export const FeatureFlag = {
    ...FeatureFlags,
    ...AlgoFeatureFlags,
    ...EHFeatureFlags,
    ...CNXFeatureFlags,
    ...HWFeatureFlags,
    ...TravelRecruitingFlags,
    ...TravelXFeatureFlags,
    ...TPFeatureFlags,
    ...WayfarersFlags,
    ...MicDropFeatureFlags,
    ...LocumsFlags,
    ...AccountManagementFeatureFlags,
    ...BabaYagaFeatureFlags,
    ...StarBucksFeatureFlags,
    ...SupersonicFeatureFlags,
    ...AccountOperationsFeatureFlags,
    ...PathfindersFlags,
    ...PayrollTimecardFeatureFlags,
    ...ItsOverNineThousandFeatureFlags,
    ...AyaWannaConnectFeatureFlags,
    ...CodeBustersFeatureFlags,
    ...ProgramManagementFeatureFlags,
    ...AyaWannaConnectFeatureFlags,
    ...SyncOrSwimFeatureFlags,
    //...SvtFeatureFlags,
    ...StaftPunkFeatureFlags,
    ...AyaKiddingMeFeatureFlags,
    ...TestFeatureFlags,
    ...PerDizzleFeatureFlags,
    ...HotFeatureFlags,
    ...ESPressoFeatureFlags
};

export type FeatureFlag =
    | FeatureFlags
    | AlgoFeatureFlags
    | EHFeatureFlags
    | CNXFeatureFlags
    | HWFeatureFlags
    | TravelRecruitingFlags
    | TravelXFeatureFlags
    | TPFeatureFlags
    | WayfarersFlags
    | MicDropFeatureFlags
    | LocumsFlags
    | AccountManagementFeatureFlags
    | BabaYagaFeatureFlags
    | StarBucksFeatureFlags
    | SupersonicFeatureFlags
    | AccountOperationsFeatureFlags
    | PathfindersFlags
    | PayrollTimecardFeatureFlags
    | ItsOverNineThousandFeatureFlags
    | AyaWannaConnectFeatureFlags
    | CodeBustersFeatureFlags
    | ProgramManagementFeatureFlags
    | SyncOrSwimFeatureFlags
    //| SvtFeatureFlags
    | StaftPunkFeatureFlags
    | AyaKiddingMeFeatureFlags
    | TestFeatureFlags
    | PerDizzleFeatureFlags
    | HotFeatureFlags
    | ESPressoFeatureFlags;
